const TYPEFORM_HOST_PATTERN = /\.typeform\.com/i;

/**
 * Corrige URLs mal formadas como .../path&user_id=xxx (sin ?).
 */
function normalizeQueryString(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const hashIndex = url.indexOf('#');
  const beforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const questionIndex = beforeHash.indexOf('?');
  const ampIndex = beforeHash.indexOf('&');

  if (ampIndex !== -1 && questionIndex === -1) {
    return `${beforeHash.slice(0, ampIndex)}?${beforeHash.slice(ampIndex + 1)}${hash}`;
  }

  return url;
}

export function isTypeformUrl(url) {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    return TYPEFORM_HOST_PATTERN.test(new URL(normalizeQueryString(url)).hostname);
  } catch {
    return TYPEFORM_HOST_PATTERN.test(url);
  }
}

export function getSessionUserId(user) {
  if (!user || typeof user !== 'object') {
    return null;
  }

  return user.id ?? user.user_id ?? user.whatsapp_account_id ?? null;
}

/**
 * En URLs de Typeform, establece user_id y schedule_id en la query.
 */
export function resolveExternalLinkUrl(url, user, scheduleId) {
  const baseUrl = url;

  if (!baseUrl || !isTypeformUrl(baseUrl)) {
    return baseUrl;
  }

  const userId = getSessionUserId(user);
  const normalized = normalizeQueryString(baseUrl);

  if (
    (userId == null || userId === '') &&
    (scheduleId == null || scheduleId === '')
  ) {
    return baseUrl;
  }

  try {
    const parsed = new URL(normalized);

    if (userId != null && userId !== '') {
      parsed.searchParams.set('user_id', String(userId));
    }
    if (scheduleId != null && scheduleId !== '') {
      parsed.searchParams.set('schedule_id', String(scheduleId));
    }

    return parsed.toString();
  } catch {
    let result = normalized;

    if (userId != null && userId !== '') {
      if (/([?&])user_id=[^&#]*/i.test(result)) {
        result = result.replace(/([?&])user_id=[^&#]*/i, `$1user_id=${userId}`);
      } else {
        const separator = result.includes('?') ? '&' : '?';
        result = `${result}${separator}user_id=${userId}`;
      }
    }

    if (scheduleId != null && scheduleId !== '') {
      if (/([?&])schedule_id=[^&#]*/i.test(result)) {
        result = result.replace(/([?&])schedule_id=[^&#]*/i, `$1schedule_id=${scheduleId}`);
      } else {
        const separator = result.includes('?') ? '&' : '?';
        result = `${result}${separator}schedule_id=${scheduleId}`;
      }
    }

    return result;
  }
}
